import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import api from '../config/api';
import { useAuth } from '../contexts/AuthContext';
import { DOCUMENT, PAGE_CONTAINER_MAX_WIDTH, documentPageContainerSx } from '../constants/documentTheme';
import { memoriesPath, MEMORIES_GUEST_TOKEN_KEY } from '../utils/memoriesHost';
import MemoriesUploadPanel from '../components/MemoriesUploadPanel';

const MemoriesUpload = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      navigate(memoriesPath(`e/${slug}`), { replace: true });
    }
  }, [user, slug, navigate]);

  useEffect(() => {
    const guestToken = localStorage.getItem(MEMORIES_GUEST_TOKEN_KEY);
    if (guestToken) {
      api.defaults.headers.common['X-Guest-Token'] = guestToken;
    }
    api.get(`/memories/events/${slug}`).then(({ data }) => {
      setEvent(data.event);
    }).catch((err) => {
      if (guestToken) {
        setEvent({ name: t('memories.title'), slug });
      } else {
        setError(err.response?.data?.error || t('memories.loadFailed'));
      }
    });
  }, [slug, t]);

  if (user) return null;

  return (
    <Box sx={{ backgroundColor: DOCUMENT.canvas, minHeight: '100vh', pb: 8 }}>
      <Container maxWidth={PAGE_CONTAINER_MAX_WIDTH} sx={{ ...documentPageContainerSx, pt: 5 }}>
        <Typography sx={{ letterSpacing: '0.16em', textTransform: 'uppercase', fontSize: 11, color: DOCUMENT.accent, mb: 1 }}>
          {t('memories.brand')}
        </Typography>
        <Typography sx={{ fontFamily: DOCUMENT.display, fontSize: 32, color: DOCUMENT.ink, mb: 3 }}>
          {event?.name || t('memories.addPhotos')}
        </Typography>
        {error && <Typography sx={{ color: '#9C3B2A', mb: 2 }}>{error}</Typography>}
        <MemoriesUploadPanel
          slug={slug}
          storageUsedBytes={event?.storage_used_bytes}
          storageQuotaMb={event?.storage_quota_mb}
        />
      </Container>
    </Box>
  );
};

export default MemoriesUpload;
